import React, { FC, HTMLAttributes } from "react";
import styled from "styled-components";
import Headline from "./Headline";
import Simulator from "./calculation/Simulator";

export type Props = HTMLAttributes<HTMLDivElement>;
const CalculationArea: FC<Props> = ({ ...props }) => {
  return (
    <Root {...props}>
      <StyledHeadline image={{ pc: "/calculation/mascot-1-pc.png", sp: "/calculation/mascot-1-sp.png", position: "right" }}>
        ＼まずは！／
        <br />
        いくら寄附できるかチェック♪
      </StyledHeadline>
      <Simulator />
    </Root>
  );
};
export default CalculationArea;

const Root = styled.div``;
const StyledHeadline = styled(Headline)`
  margin: 20px 0;
`;
